import { useState, useEffect } from "react";
import {
  Box,
  Button,
  CardMedia,
  Card,
  TextField,
  Menu,
  Typography,
  Avatar,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../../main/detail/Detail";
import {
  rsActiveMenu,
  rsProgress,
  rsParentCom,
} from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingLinkGrid } from "./UseLandingLinkGrid";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../../hooks/useBreakpoints";
import { SketchPicker } from "react-color";

export default function AddLandingLinkGridItem(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { addLandingLinkGridItem } = UseLandingLinkGrid();
  const { isSmall } = useBreakpoints();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [anchorElBorder, setAnchorElBorder] = useState(null);
  const openBorder = Boolean(anchorElBorder);
  const [anchorElBack, setAnchorElBack] = useState(null);
  const openBack = Boolean(anchorElBack);

  const [state, setState] = useState({
    categoryID: undefined,
    rowIndex: undefined,
    title: "",
    borderColor: null,
    backColor: null,
    textColor: null,
    description: undefined,
    url: undefined,
    width: undefined,
    height: undefined,
  });

  const [imgState, setImgState] = useState({
    imageFile: undefined,
    imageUrl: undefined,
    iconeFile: undefined,
    iconeUrl: undefined,
  });

  useEffect(() => {
    if (location.state && location.state.rows && location.state.itemID) {
      var lastrowIndex = Math.max.apply(
        Math,
        location.state.rows.map(function (o) {
          return o.rowIndex;
        }),
      );
      setState({
        ...state,
        categoryID: location.state.itemID,
        rowIndex: lastrowIndex != -Infinity ? lastrowIndex + 1 : 1,
      });
    }
  }, [location.state]);

  const handleChangeIcone = (file) => {
    const img = new Image();
    img.src = URL.createObjectURL(file[0]);
    img.onload = () => {
      setState({ ...state, width: img.width, height: img.height });
    };
    setImgState({
      ...imgState,
      iconeFile: file[0],
      iconeUrl: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage = (file) => {
    setImgState({
      ...imgState,
      imageFile: file[0],
      imageUrl: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/landingmanagment/landingComponents/linkGrid",
            LandingLinkGridID:
              location.state.LandingLinkGridID &&
              location.state.LandingLinkGridID,
            componentFaTitle: location.state.componentFaTitle,
          },
          {
            name: "افزودن آیتم",
            url: "/landingmanagment/landingComponents/linkGrid/addItem",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.url ? state.url : ""}
              label="آدرس"
              size="small"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, url: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}{" "}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn="span 12"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeIcone(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "80px", height: "auto", mr: 5 }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.iconeUrl
                          ? imgState.iconeUrl
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
            <TextField
              fullWidth
              value={state.width ? state.width : ""}
              label="عرض"
              sx={{
                input: {
                  direction: "rtl",
                },
                width: isSmall ? "50%" : "15%",
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, width: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              fullWidth
              value={state.height ? state.height : ""}
              label="طول"
              sx={{
                input: {
                  direction: "rtl",
                },
                width: isSmall ? "50%" : "15%",
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, height: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "170px", height: "auto" }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.imageUrl
                          ? imgState.imageUrl
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn="span 3">
            <Box
              sx={{
                p: 1,
                border: "1px",
                borderStyle: "dashed",
                borderColor: "secondary.main",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="body1"> رنگ متن :</Typography>
              <Avatar
                sx={{
                  bgcolor: state.textColor,
                  boxShadow: 3,
                  width: 35,
                  height: 35,
                  mx: 1,
                }}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => {
                  setAnchorEl(event.currentTarget);
                }}
              >
                {" "}
              </Avatar>
              <Typography variant="body1">
                {state.textColor ? state.textColor : ""}
              </Typography>{" "}
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              sx={{
                "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                  py: 0,
                },
              }}
            >
              <SketchPicker
                sx={{ position: "relative", top: "-130px" }}
                color={state.textColor ? state.textColor : ""}
                onChangeComplete={(color) => {
                  setState({ ...state, textColor: color.hex });
                }}
              />
            </Menu>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn="span 3">
            <Box
              sx={{
                p: 1,
                border: "1px",
                borderStyle: "dashed",
                borderColor: "secondary.main",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="body1"> رنگ لبه :</Typography>
              <Avatar
                sx={{
                  bgcolor: state.borderColor,
                  boxShadow: 3,
                  width: 35,
                  height: 35,
                  mx: 1,
                }}
                id="basic-button"
                aria-controls={openBorder ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openBorder ? "true" : undefined}
                onClick={(event) => {
                  setAnchorElBorder(event.currentTarget);
                }}
              >
                {" "}
              </Avatar>
              <Typography variant="body1">
                {state.borderColor ? state.borderColor : ""}
              </Typography>{" "}
            </Box>
            <Menu
              anchorEl={anchorElBorder}
              open={openBorder}
              onClose={() => setAnchorElBorder(null)}
              sx={{
                "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                  py: 0,
                },
              }}
            >
              <SketchPicker
                sx={{ position: "relative", top: "-130px" }}
                color={state.borderColor ? state.borderColor : ""}
                onChangeComplete={(color) => {
                  setState({ ...state, borderColor: color.hex });
                }}
              />
            </Menu>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn="span 3">
            <Box
              sx={{
                p: 1,
                border: "1px",
                borderStyle: "dashed",
                borderColor: "secondary.main",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="body1"> رنگ زمینه :</Typography>
              <Avatar
                sx={{
                  bgcolor: state.backColor,
                  boxShadow: 3,
                  width: 35,
                  height: 35,
                  mx: 1,
                }}
                id="basic-button"
                aria-controls={openBack ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openBack ? "true" : undefined}
                onClick={(event) => {
                  setAnchorElBack(event.currentTarget);
                }}
              >
                {" "}
              </Avatar>
              <Typography variant="body1">
                {state.backColor ? state.backColor : ""}
              </Typography>{" "}
            </Box>
            <Menu
              anchorEl={anchorElBack}
              open={openBack}
              onClose={() => setAnchorElBack(null)}
              sx={{
                "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                  py: 0,
                },
              }}
            >
              <SketchPicker
                sx={{ position: "relative", top: "-130px" }}
                color={state.backColor ? state.backColor : ""}
                onChangeComplete={(color) => {
                  setState({ ...state, backColor: color.hex });
                }}
              />
            </Menu>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              onClick={() => {
                setProgress(true);
                addLandingLinkGridItem(
                  state,
                  imgState.imageFile,
                  imgState.iconeFile,
                  (calback) => {
                    navigate("/landingmanagment/landingComponents/linkGrid", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  },
                );
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/landingmanagment/landingComponents/linkGrid", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      </Box>
    </Detail>
  );
}
